const mockPoints =
[
  {
    'id': '0',
    'base_price': 970,
    'date_from': '2022-10-24T13:05:46.876Z',
    'date_to': '2022-10-30T08:05:46.876Z',
    'destination': 'ba5f43a3-d91d-45dc-b83f-a28fa3faebec',
    'is_favorite': false,
    'offers': [],
    'type': 'taxi'
  },
  {
    'id': '1',
    'base_price': 1647,
    'date_from': '2027-02-24T08:05:46.876Z',
    'date_to': '2027-02-25T14:05:46.876Z',
    'destination': 'a2b1a841-f72b-4e13-a3a7-dc9686835641',
    'is_favorite': false,
    'offers': [],
    'type': 'bus'
  },
  {
    'id': '2',
    'base_price': 1503,
    'date_from': '2029-02-25T14:05:46.876Z',
    'date_to': '2029-02-27T02:05:46.876Z',
    'destination': 'a2b1a841-f72b-4e13-a3a7-dc9686835641',
    'is_favorite': true,
    'offers': [],
    'type': 'sightseeing'
  },
  {
    'id': '3',
    'base_price': 212,
    'date_from': '2029-03-02T00:05:46.876Z',
    'date_to': '2029-03-04T00:05:46.876Z',
    'destination': '871888aa-5dbf-4601-b7dc-14eebf151f6c',
    'is_favorite': true,
    'offers': [
      '5bd93df9-76c8-4574-8087-8a210f6241ac',
      '0dc304c1-e265-4474-b031-157ce0a5b1b3',
      '2ce6c82b-8d96-4f54-957c-70a265d35d1b'
    ],
    'type': 'flight'
  },
  {
    'id': '4',
    'base_price': 9289,
    'date_from': '2029-03-04T06:05:46.876Z',
    'date_to': '2029-03-05T19:05:46.876Z',
    'destination': '2ce7b3bb-ee15-4f13-95f0-550b57a9426f',
    'is_favorite': true,
    'offers': [
      'b3f3deb1-4449-48ac-b128-b14f979fd97c',
      'eb57a2c9-aed0-41eb-9a1c-2a2a617a45a6'
    ],
    'type': 'ship'
  },
  {
    'id': '5',
    'base_price': 3901,
    'date_from': '2029-03-05T19:05:46.876Z',
    'date_to': '2029-03-07T16:05:46.876Z',
    'destination': '871888aa-5dbf-4601-b7dc-14eebf151f6c',
    'is_favorite': false,
    'offers': [
      'a25e8cbf-c5b7-4ee9-9626-321ef54cc2a2',
      '3f600534-be68-4624-8e6c-4c50094e0a6d',
      'd7d4501f-ef33-4fa0-b8bb-826f3be524ac'
    ],
    'type': 'check-in'
  }
];

export {mockPoints};
